import { FirmContext } from "../contexts/AuthContext";

export const isSuperAdmin = (firmContext: FirmContext | null | undefined): boolean => {
  if (!firmContext?.permissions) return false;
  return Boolean(firmContext.permissions.super_admin);
};
